import React from "react";
import { Link } from "react-router-dom";
import Login from "../components/Login/Login";
import register from "../components/Login/Media/Register.json";
import Lottie from "lottie-react";
import TopBar from "../components/TopBar";
import ProgressBar from "../components/ProgressBar";

function LoginPage() {
  return (
    <div>
      <ProgressBar />
      <TopBar />
      <div className="container-fluid ">
        <div className="row ">
          <div className=" hidden md:flex col-12 col-md-6 flex flex-col justify-center align-items-center login-left">
            <Lottie
              animationData={register}
              loop
              autoplay
              style={{
                width: "300px",
                height: "300px",
                background: "transparent",
                scale: 5,
              }}
            />
            <h1 className="text-[32px] text-white">Not yet Registered?</h1>
            <p className="text-[18px] text-white w-[60%] text-center mt-[20px]">
              Register now to begin your journey into the .gold revolution
            </p>
            <Link to="/SignUp" className="mt-[30px]">
              <button className="join-btn custom-btn main-buttonn w-full !mt-[16px]">
                Register For Free
              </button>
            </Link>
          </div>
          <div className="col-12 col-md-6  login-right pattern-bg2">
            {" "}
            <Login />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
